import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  makeStyles
} from '@material-ui/core';
import { Add } from '@material-ui/icons';
import { useKeycloak } from '@react-keycloak/web';
import { inject, observer } from 'mobx-react';
import { withSnackbar } from 'notistack';
import React, { useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import ConfirmDialog from '../../../components/CustomDialog';
import DocumentPreview from '../../../components/DocumentPreview';
import Tracking from '../../../components/tracking/Tracking';
import DataTable from '../../../toolkit/DataTable/DataTable';
import ListDataProvider from '../../../toolkit/mobx-connectors/ListDataProvider';
import axios from '../../../utils/axios';
import { fetchPdfAsBase64 } from '../../../utils/form-utils';
import createParams from '../../../utils/tables-params';
import formulariosConfig from './FormularioConfig';

const useStyles = makeStyles(theme => ({
  container: {
    paddingBottom: theme.spacing(8),
    [theme.breakpoints.down('sm')]: {
      paddingBottom: 0,
      padding: 0
    }
  },
  img: {
    width: '150px',
    [theme.breakpoints.down('sm')]: {
      width: '100px'
    }
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.short
    })
  },
  expandOpen: {
    transform: 'rotate(180deg)'
  },
  paper: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    padding: theme.spacing(4),
    marginLeft: theme.spacing(6),
    marginRight: theme.spacing(6),
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
      marginRight: 0,
      marginTop: 0,
      marginBottom: theme.spacing(5),
      padding: theme.spacing(2),
      paddingTop: theme.spacing(4)
    }
  },
  tableCellAction: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    whiteSpace: 'nowrap'
  },
  button: {
    margin: 0,
    textDecoration: 'none',
    marginLeft: theme.spacing(1)
  },
  addButon: {
    padding: '15px'
  },
  leftIcon: {
    marginRight: theme.spacing(1)
  },
  rightIcon: {
    marginLeft: theme.spacing(1)
  },
  iconSmall: {
    fontSize: 20
  },

  toolbar: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  cardStyle: {
    borderRadius: '4px 4px 0px 0px'
  }
}));

const FormularioList = props => {
  const { gridProps } = props;
  const { enqueueSnackbar } = props;
  const classes = useStyles();
  const history = useHistory();
  const [pdfPreview, setPdfPreview] = useState();
  const [pdfDespachoPreview, setPdfDespachoPreview] = useState();
  const [openConfirm, setOpenConfirm] = useState(false);
  const [deleteConfirmConfig, setDeleteConfirmConfig] = useState({
    open: false
  });

  const { keycloak } = useKeycloak();
  const gruposList = keycloak.tokenParsed.groups || [];
  const esExportador =
    gruposList.includes('GRUPO_EXPORTADOR') ||
    gruposList.includes('GR_REG_EMPRESA_V2') ||
    gruposList.includes('GR_REG_EMPRESA_V3');
  const tableRef = useRef(null);

  const handleClose = () => {
    setOpenConfirm(false);
  };

  const handleOk = () => {
    setOpenConfirm(false);
  };

  const onPdfView = async value => {
    try {
      setPdfPreview({
        url: '',
        title: 'Formulario EF'
      });
      const url = await fetchPdfAsBase64(
        `${process.env.REACT_APP_ROOT_API}reporte/generaPdf?formularioId=${
          value.id
        }`
      );
      setPdfPreview({
        url,
        title: 'Formulario EF',
        download: `formulario-${value.exportador.ruc}-${value.id}`
      });
    } catch (err) {
      console.log(err);
    }
  };

  const onPdfDespachoView = async value => {
    try {
      setPdfDespachoPreview({
        url: '',
        title: 'Despacho'
      });
      const url = await fetchPdfAsBase64(
        `${
          process.env.REACT_APP_ROOT_API
        }reporte/generaPdfDespacho?formularioId=${value.id}`
      );
      setPdfDespachoPreview({
        url,
        title: 'Despacho',
        download: `despacho-${value.exportador.ruc}-${value.id}`
      });
    } catch (err) {
      console.log(err);
    }
  };

  const onTrackingView = () => {
    setOpenConfirm(true);
  };

  const onAgregar = () => {
    history.push('/formulario');
  };

  const onEdit = formulario => {
    history.push(`/formulario-view/${formulario.id}`);
  };

  const onDelete = async item => {
    try {
      await axios.delete(`formularios/${item.id}`);
      enqueueSnackbar('Eliminado correctamente', { variant: 'success' });
      tableRef.current.reload();
    } catch (err) {
      console.log('error', err);
      enqueueSnackbar('Ocurrió un error al intentar eliminar', {
        variant: 'warning'
      });
    }
  };

  const onDeletePre = item => {
    setDeleteConfirmConfig({
      open: true,
      onConfirm: () => {
        setDeleteConfirmConfig(prev => ({ ...prev, open: false }));
        onDelete(item);
      },
      title: 'Eliminar Formulario',
      description: `Se eliminará toda la información del formulario y no podrá recuperarla`,
      cancelText: 'Cancelar',
      okText: 'Eliminar',
      onCancel: () => setDeleteConfirmConfig(prev => ({ ...prev, open: false }))
    });
  };

  const configuraciones = formulariosConfig({
    classes,
    enqueueSnackbar,
    onPdfView,
    onPdfDespachoView,
    onEdit,
    onDelete: onDeletePre,
    onTrackingView
  });
  const dataset = 'formularios';

  const { datosConfig } = configuraciones[dataset];
  const { datosSettings } = configuraciones[dataset];

  const onReloadTable = () => {
    const settings = datosSettings;
    const params = createParams({ ...props.formularios.list, settings });
    axios
      .get(datosConfig.servicio, {
        data: {},
        params
      })
      .then(resp => {
        return props.formularios.list.dataLoaded(resp.data.data, {
          currentPage: resp.data.meta.currentPage - 1,
          pageSize: resp.data.meta.pageSize,
          itemsCount: resp.data.meta.total
        });
      })
      .catch(() => {
        enqueueSnackbar('Error al obtener los datos', 'error');
      });
  };

  const details = [
    {
      fecha: '07:00 01/11/2024',
      titulo: 'Llegado a la instalación regional de USPS',
      subtitulo: 'CENTRO DE DISTRIBUCIÓN AUSTIN TX'
    },
    {
      fecha: '08:00 01/11/2024',
      titulo: 'En tránsito hacia la siguiente instalación'
    },
    {
      fecha: '09:00 01/11/2024',
      titulo: 'Llegado a la instalación de origen de USPS',
      subtitulo: 'SAINT PAUL, MN 55131'
    },
    {
      fecha: '10:00 01/11/2024',
      titulo: 'Entregado',
      subtitulo: 'CIRCLE PINES'
    }
  ];

  return (
    <>
      <Grid container {...gridProps}>
        <Dialog
          open={openConfirm}
          onClose={handleClose}
          aria-labelledby="dialog-title"
        >
          <DialogTitle id="dialog-title">Estado del envío</DialogTitle>
          <DialogContent>
            <Tracking details={details} />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleOk} color="primary" variant="contained">
              OK
            </Button>
          </DialogActions>
        </Dialog>
        <ConfirmDialog {...deleteConfirmConfig} />
        <ListDataProvider
          listStore={props.formularios.list}
          render={listProps => (
            <DataTable
              ref={tableRef}
              title={datosConfig.titulo}
              settings={datosSettings}
              onReloadTable={() => onReloadTable()}
              fileName={datosConfig.servicio}
              toolbarActionsEnd={
                esExportador && [
                  <Button
                    variant="outlined"
                    key="agregar"
                    color="primary"
                    className={classes.button}
                    startIcon={<Add />}
                    onClick={onAgregar}
                  >
                    Agregar
                  </Button>
                ]
              }
              {...listProps}
            />
          )}
        />
        {pdfPreview && (
          <DocumentPreview
            title={pdfPreview.title}
            file={pdfPreview.url}
            download={pdfPreview.download}
            onClose={() => {
              setPdfPreview();
            }}
          />
        )}
        {pdfDespachoPreview && (
          <DocumentPreview
            title={pdfDespachoPreview.title}
            file={pdfDespachoPreview.url}
            download={pdfDespachoPreview.download}
            onClose={() => {
              setPdfDespachoPreview();
            }}
          />
        )}
      </Grid>
    </>
  );
};

export default inject('formularios')(observer(withSnackbar(FormularioList)));
